import styled from 'styled-components'
import { Flex, Icon, Modal } from 'components'
import Field, { Props as FieldProps } from 'components/Field'
import { ApiKey } from 'services/types/api-key'
import { useTranslation } from 'react-i18next'

type Props = {
  data: ApiKey['rules']
  onClose?: () => void
}

const rulesOwnerName = (fname: string | null, lname: string | null) => (fname || lname ? `${fname} ${lname}` : null)

const campaignName = (campaign: string | null) => (campaign ? campaign : 'None')

const RulesModal = ({ data, onClose }: Props) => {
  const { t } = useTranslation()
  return (
    <Modal visible onClose={onClose} title="Rules" isFooterVisible={false}>
      {data.map((rule, index) => (
        <RuleContainer key={index}>
          <RuleField label="Campaign">{campaignName(rule.campaign.campaign_name)}</RuleField>
          <RuleField label="Lead source">{rule.lead_source.lead_source_name}</RuleField>
          <RuleField label="Sales pipeline">{rule.lead_process}</RuleField>
          <RuleField label="Lead owner">
            {rule.lead_owner.team_name ? (
              <Flex gap="0.5rem" color="defaultText">
                <Icon icon={['far', 'users']} color="defaultText" />
                {rule.lead_owner.team_name}
              </Flex>
            ) : (
              rulesOwnerName(rule.lead_owner.fname, rule.lead_owner.lname) ?? t('unassigned_lbl')
            )}
          </RuleField>
        </RuleContainer>
      ))}
    </Modal>
  )
}

const RuleField = (props: FieldProps) => <Field variant="borderless" labelBold textColor="defaultText" {...props} />

const RuleContainer = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.defaultBorder};
  border-radius: 4px;
  padding: 1rem;
  margin-bottom: 1rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export default RulesModal
